import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class FormsListRow {
  static props = ['href', 'name', 'status', 'isPublic', 'createdAt', 'createdBy'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.name }}
    td.pr-4 {{ Props.status }}
    td.pr-4 {{ Props.isPublic }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.createdBy }}
  `;
}

export class FormsList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/forms/create"] Create form
    <PageTitle title="Forms">
    table.resource-table[data-empty-title="No forms yet" data-empty-description="Create a form to collect information from your users." data-empty-action="Create form" data-empty-href="/forms/create"]
      thead
        th Name
        th.pr-4 Status
        th.pr-4 Public
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#forms-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('forms'))
      .then(response => {
        appendDataToListTable('#forms-list-rows', response.data, FormsListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#forms-list-rows', error, 'Forms'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.name}`,
      name: item.name,
      status: item.status || '',
      isPublic: item.isPublic ? 'Yes' : 'No',
      createdAt: Util.formatDate(item.createdAt),
      createdBy: item.createdBy || ''
    };
  }
}
